import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./ClientReviews.css"; // Import CSS

// Review data
const reviews = [
  { name: "Bang Upin", role: "Pedagang Asongan", text: "“Terimakasih banyak, kini ruanganku menjadi lebih mewah dan terlihat mahal”", emoji: "🛍️" },
  { name: "Ibuk Sukijan", role: "Ibu Rumah Tangga", text: "“Makash Panto, aku sekarang berasa tinggal di apartmen karena barang-barang yang terlihat mewah”", emoji: "🏡" },
  { name: "Mpok Ina", role: "Karyawan Swasta", text: "“Sangat terjangkau untuk kantong saya yang tidak terlalu banyak”", emoji: "💰" },
  { name: "Bang Upin", role: "Pedagang Asongan", text: "“Terimakasih banyak, kini ruanganku menjadi lebih mewah dan terlihat mahal”", emoji: "🛍️" },
  { name: "Ibuk Sukijan", role: "Ibu Rumah Tangga", text: "“Makash Panto, aku sekarang berasa tinggal di apartmen karena barang-barang yang terlihat mewah”", emoji: "🏡" },
  { name: "Mpok Ina", role: "Karyawan Swasta", text: "“Sangat terjangkau untuk kantong saya yang tidak terlalu banyak”", emoji: "💰" },


];

const ClientReviews = () => {
  return (
    <div className="client-reviews">
      <br></br><br></br><br></br>
      <h2>Our Client Reviews</h2>
<br></br><br></br><br></br>

      {/* Swiper container */}
      <Swiper
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        modules={[Navigation]}
        loop={true}
        spaceBetween={30}
        breakpoints={{
          320: { slidesPerView: 1 }, // 1 card per row on small screens
          768: { slidesPerView: 2 }, // 2 cards per row on tablets
          1024: { slidesPerView: 3 }, // 3 cards per row on large screens
        }}
      >
        {reviews.map((review, index) => (
          <SwiperSlide key={index}>
            <div className="review-card">
              <div className="review-image"></div>
              <div className="review-avatar">{review.emoji}</div>
              <div className="review-content">
                <h3>{review.name}</h3>
                <p className="review-role">{review.role}</p>
                <p className="review-text">{review.text}</p>
                <div className="review-stars">⭐️⭐️⭐️⭐️</div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Navigation Buttons */}
      <div className="swiper-button-prev">❮</div>
      <div className="swiper-button-next">❯</div>
    </div>
  );
};

export default ClientReviews;
